<script>
import AppDisplay from '@/components/AppDisplay.vue'
import Bioinsumos from '../components/Bioinsumos.vue'
import Irrigacao from '../components/Irrigacao.vue'
import Financiamento from '../components/Financiamento.vue'
import Descricao from '../components/Descricao.vue'
import { formataStringYearMonthToBr } from '@/utils/utils'
import { opcoesGrauDegradacao, opcoesTecnicaRecuperacao } from '@/libs/constants/praticas/opcoesSelects'

export default {
  components: {
    AppDisplay,
    Bioinsumos,
    Irrigacao,
    Financiamento,
    Descricao
  },
  props: {
    pratica: {
      type: Object
    }
  },
  methods: {
    formataDataInicio (value) {
      if (!value) return ''
      return formataStringYearMonthToBr(value)
    },
    formataGrauDegradacao (value) {
      if (!value) return ''
      return opcoesGrauDegradacao.find(opcao => opcao.id === value)?.nome
    },
    formataTecnicasUtilizadas (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.filter(v => v !== 'OUTROS').map(value => opcoesTecnicaRecuperacao.find(opcao => opcao.id === value)?.nome)
      return opcoesFormatadas.join(', ')
    }
  }
}
</script>

<template>
  <div>
    <div>
      <span class="title-praticas">Dados da prática</span>
      <hr />
    </div>
    <el-row>
      <el-col :span="12">
        <app-display label="Área destinada à recuperação (em hectares):" :content="pratica.areaDestinada" />
        <app-display label="Data que o processo de recuperação foi iniciado (mês e ano):" :content="formataDataInicio(pratica.dataInicio)" />
        <app-display label="Grau de degradação da área:" :content="formataGrauDegradacao(pratica.grauDegradacao)" />
      </el-col>
      <el-col :span="12">
        <app-display label="Foi realizada análise de solo antes da recuperação?:" :content="pratica.hasAnaliseSolo ? 'Sim' : 'Não'" />
        <app-display label="Técnica utilizada na recuperação da área:" :content="formataTecnicasUtilizadas(pratica.tecnicasUtilizadas)" />
        <app-display v-if="pratica.tecnicasUtilizadas && pratica.tecnicasUtilizadas.length" label="Outras técnicas utilizadas:" :content="pratica.outrosTecnicasUtilizadas" />
      </el-col>
    </el-row>
    <Bioinsumos :bioinsumo="{utilizaBioinsumos: pratica.utilizaBioinsumos, bioinsumos: pratica.bioinsumos}" />
    <Irrigacao :irrigacao="{possuiIrrigacao: pratica.possuiIrrigacao, ...pratica.irrigacao}" />
    <Financiamento :financiamento="{financiamentos: pratica.financiamentos, outroFinanciamento: pratica.outroFinanciamento}" />
    <Descricao :descricao="pratica.descricao" />
  </div>
</template>

<style lang="scss" scoped>
  @import '../style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/PRPD/PRPD.vue